import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry for error tracking and performance monitoring
 * Landing Page - Public-facing marketing site
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development';

  // Only initialize if DSN is provided
  if (!dsn) {
    console.warn('Sentry DSN not found. Error tracking is disabled.');
    return;
  }

  Sentry.init({
    dsn,
    environment,

    // Integrations
    integrations: [
      // Browser tracing for performance monitoring
      Sentry.browserTracingIntegration(),
      // Replay integration for session replay (optional)
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0, // 10% in prod, 100% in dev

    // Trace propagation targets (for distributed tracing)
    tracePropagationTargets: ['localhost', /^\//],

    // Session Replay
    replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0, // 10% in prod
    replaysOnErrorSampleRate: 1.0, // Always capture on error

    // Release tracking
    release: import.meta.env.VITE_SENTRY_RELEASE,

    // Additional options
    beforeSend(event) {
      // Filter out specific errors if needed
      return event;
    },

    // Ignore common non-critical errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // Network errors
      'NetworkError',
      'Network request failed',
    ],
  });
}
